import { ReactNode } from 'react';
import { Download } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useLocale } from '../../Shared/locale';
import { Card } from '../../Shared/UI/Card';
import { Icon } from '../../Shared/UI/Icon';
import { Charity, Invoice, SharedProps } from '../types';
import Container from '../UI/Container';
import Layout from '../UI/Layout';
import { CharitySettingsLayout } from './CharitySettingsLayout';

export interface InvoicesPageProps extends SharedProps {
  invoices: Invoice[];
  charity: Charity;
}

export default function InvoicesPage({
  invoices,
}: InvoicesPageProps) {
  const { t } = useTranslation();
  const { formatDate, formatCurrency } = useLocale();

  return (
    <Container size="md" className="space-y-6">
      <Card panels header>
        <div>
          <h3>
            {t('backend:invoices')}
          </h3>
        </div>
        <div className="divide-y divide-slate-150">
          <div className="mb-6">
            {t('backend:invoices_for_recurring_donations')}
          </div>
          {invoices.map((invoice) => (
            <div className="grid grid-cols-[4fr_7fr_4fr_3fr] gap-2 py-2" key={invoice.id}>
              <div>
                <a href={invoice.download_url} target="_blank" rel="noopener noreferrer">
                  {invoice.invoice_id}
                  <Icon className="ml-1">
                    <Download />
                  </Icon>
                </a>
              </div>
              <div>
                {invoice.organisation}
              </div>
              <div>
                {formatDate(invoice.start_date, 'display_month')}
              </div>
              <div className="text-right">
                {formatCurrency(invoice.gross_amount)}
              </div>
            </div>
          ))}
          {invoices.length === 0 && (
            <div className="text-slate-500 py-2">
              {t('backend:no_invoices_yet')}
            </div>
          )}
        </div>
      </Card>
    </Container>
  );
}

InvoicesPage.layout = (page: ReactNode) => <Layout><CharitySettingsLayout>{page}</CharitySettingsLayout></Layout>;
